module.exports = __webpack_public_path__ + "img/official-verification-icon2.0dc282db.svg";